
import { 
    Container,
} from "react-bootstrap";
import {
    logoGreen,
    // rettaGreen
} from "assets/images"
import moment from 'moment'

function PDFPage1(props: any) {
    const createdAt = moment().format('DD. MMMM YYYY');
    
    return (
        <>
            <Container fluid className="py-3 cu-bg-green2 px-5 page-size">
                <div className="d-flex justify-content-end px-3 pt-3">
                    <img src={logoGreen} alt="Retta Logo" width="200"/>
                </div>
                <div className="d-flex align-items-center" style={{minHeight:"400px"}}>
                    <div className="text-left cu-text-lightgreen2">
                        <h2 className="cu-text-lightgreen2">
                            {props?.customerDetails?.customer_name}
                        </h2>
                        <h2 className="cu-text-lightgreen2">
                            {props.TranslateString('analyysi indikatiivista tarjousta varten')}
                        </h2>
                        <h6 className="cu-text-lightgreen2 mb-0">
                            {
                                createdAt?.split(" ").map((element:any,index:any)=>{
                                    if(index===0){
                                        element = `${element.match(/\d+/g)[0]}.`;
                                    }
                                    // else if(index===1){
                                    //     element = props.TranslateString(element);
                                    // }
                                    return element;
                                }).join(" ")
                            }
                        </h6>
                    </div>
                </div>
            </Container>
        </>
    );
}

export default PDFPage1;